import standardAction from '../../../utilities/standard-action';
import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function newOrgNameChange(currentValue: string): RootActionTypes {
  return standardAction(ActionTypes.ACCT_ORG_NEW_NAME_CHANGE, currentValue);
}
